import * as types from '@/store/types'
export default {
    addBot(context, payload) {
        context.bots.push(payload)
    },
    botAll(context, payload) {
        context.bots = payload
        context.loadedBots = true
    },
    setBot: (context, payload) => {
        const index = context.bots.findIndex(item => item.id === payload.id)
        context.bots[index] = payload
    },
    removeBot: (context, id) => {
        const index = context.bots.findIndex(item => item.id === id)
        context.bots.splice(index, 1)
    },
    changeBotIdModelModeratorDefault: (context, botId) => {
        context.modelModeratorDef.bot_id = botId
    },
    loadModerators(context, payload) {
        context.moderators = payload
    },
    addModerator(context, payload) {
        context.moderators.push(payload)
    },
    removeModerator(context, id) {
        const index = context.moderators.findIndex(item => item.id === id)
        context.moderators.splice(index, 1)
    },
    tariffAll(context, payload) {
        context.tariffs = payload
    }
}
